import { apiRoot, db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import axios from "axios";
import {startLoading, stopLoading} from "../loader";

export async function createFolder(userInfos, folder) {
  startLoading();

  const res = await axios.post(
    apiRoot + "/api/v1/folders/create",
    { folder },
    {
      headers: {
        Authorization: userInfos.jwt,
      },
    }
  );

  stopLoading();

  return res.data;
}

export async function updateFolder(userInfos, folder) {
  startLoading();
  await db.ref(`users/${userInfos.uid}/folders/${folder.id}`).update(folder);
  stopLoading();
}

export async function deleteFolder(userInfos, folder_id) {
  if (!Array.isArray(folder_id)) {
    folder_id = [folder_id];
  }

  startLoading();

  let pList = folder_id.map(async (id) => {
    try {
      const res = await axios.post(
        apiRoot + "/api/v1/folders/delete",
        { folderId: id },
        {
          headers: {
            Authorization: userInfos.jwt,
          },
        }
      );

      return res?.data;
    } catch (e) {
      console.error("ERROR WHEN DELETING FOLDER\nError: ", e);
      return e;
    }
  });

  const res = await Promise.allSettled(pList);

  stopLoading();

  return res;
}

export function useFolders() {
  const { userInfos } = useContext(UserContext);
  const [folders, setFolders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/folders")
      .once("value")
      .then((snapshot) => {
        let res = [];
        snapshot.forEach(function (childSnapshot) {
          res.push({
            id: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        setFolders(res);
        setLoaded(true);
      });
  }, [userInfos.uid]);

  return { folders, loaded };
}

export function useFolder(folderId) {
  const { userInfos } = useContext(UserContext);
  const [folder, setFolder] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function initFolder() {
      const snapshot = await db
        .ref(`users/${userInfos.uid}/folders/${folderId}`)
        .once("value");
      let _folder = snapshot.val();

      setFolder(_folder);
      setLoaded(true);
    }

    initFolder().then();
  }, [folderId, userInfos.uid]);

  return { folder, loaded };
}
